import Addons from './addons';
import Profile from './auth/Profile';
import Collaborator from './collaborators';
import Customers from './customers';
import Destinations from './destinations';
import Home from './home';
import OpPaymentMethod from './op-payment-method';
import Operators from './operators';
import BusOrder from './order';
import Order from './order';
import BusOrderReport from './order/bookingReport';
import Orders from './orders';
import PaymentMethod from './paymentMethod';
import PaymentMethods from './paymentMethord';
import Posts from './posts';
import Rates from './rates';
import RecentActivity from './recent-activity';
import SmsActivity from './recent-activity/smsActivity';
import Routes from './routes';
import SeatLocked from './seat-locked/SeatLocked';
import SeatMap from './seat-map';
import Settings from './settings';
import Trips from './trips';
import PassengerByRoute from './trips/passengerRoute';
import Users from './users';
import UsersAdmin from './users/userAdmin';
import Vehicles from './vehicles';

export const routes = [
  {
    path: 'home',
    component: Home,
    permission: null,
  },
  {
    path: 'seat-map',
    component: SeatMap,
    permission: null,
  },
  {
    path: 'operators',
    component: Operators,
    permission: null,
  },
  {
    path: 'destinations',
    component: Destinations,
    permission: null,
  },
  {
    path: 'vehicles',
    component: Vehicles,
    permission: null,
  },
  {
    path: 'routes',
    component: Routes,
    permission: null,
  },
  {
    path: 'payment-method',
    component: PaymentMethod,
    permission: null,
  },
  {
    path: 'op-payment-method',
    component: OpPaymentMethod,
    permission: null,
  },
  {
    path: 'orders',
    component: BusOrder,
    permission: null,
  },
  {
    path: 'collaborators',
    component: Collaborator,
    permission: null,
  },
  {
    path: 'booking_statistic',
    component: BusOrderReport,
    permission: null,
  },
  {
    path: 'posts',
    component: Posts,
    permission: null,
  },
  {
    path: 'seat-lock',
    component: SeatLocked,
    permission: null,
  },
  {
    path: 'rates',
    component: Rates,
    permission: null,
  },
  {
    path: 'rates',
    component: Rates,
    permission: null,
  },
  {
    path: 'settings',
    component: Settings,
    permission: null,
  },
  {
    path: 'customers',
    component: Customers,
    permission: null,
  },
  {
    path: 'recent-activity',
    component: RecentActivity,
    permission: null,
  },
  {
    path: 'users',
    component: Users,
    permission: null,
  },

  {
    path: 'addons',
    component: Addons,
    permission: null,
  },

  {
    path: 'seat-lock',
    component: SeatLocked,
    permission: null,
  },
  {
    path: 'trips',
    component: Trips,
    permission: null,
  },
  {
    path: 'passenger-route/:id',
    component: PassengerByRoute,
    permission: null,
  },
  {
    path: 'sms-activity',
    component: SmsActivity,
    permission: null,
  },
  {
    path: 'user-Admin',
    component: UsersAdmin,
    permission: null,
  },
  {
    path: 'profile',
    component: Profile,
    permission: null,
  },
];
